import { ActionReducerMap, createReducer, on } from "@ngrx/store";

import { BannersData, SupportInfos } from "@hermes/api-model-shell";

import { SHELL_APPEARANCE_FULL } from "@hermes/utils-generic-constants";

import * as ShellActions from "../actions/shell.actions";
import {
    HeaderBasketState,
    LocalesState,
    ShellState,
    State,
} from "../state/shell.state";

import { footerItemsReducer } from "./footer-items.reducer";

export const initialShellState: ShellState = {
    mode: SHELL_APPEARANCE_FULL,
};

export const initialBasketState: HeaderBasketState = {
    totalItems: 0,
};

export const initalLocalesState: LocalesState = {
    activatedLocales: undefined,
    countrySelectorData: undefined,
};

export const initalSupportInfoState: SupportInfos =
    undefined as unknown as SupportInfos;

export const basketReducer = createReducer(
    initialBasketState,
    on(ShellActions.updateBasket, (state, { amount }) => ({
        ...state,
        totalItems: amount,
    })),
);
// empty initial state for createReducer typing
export const initialBannersState: BannersData =
    undefined as unknown as BannersData;
/**
 * banners
 */
export const bannersReducer = createReducer(
    initialBannersState,
    on(
        ShellActions.fetchBannersSuccess,
        (state, { data }) =>
            ({
                ...state,
                ...data,
            }) as BannersData,
    ),
    on(
        ShellActions.fetchBannersFailure,
        (state) =>
            ({
                ...state,
            }) as BannersData,
    ),
);

export const shellReducer = createReducer(
    initialShellState,
    on(ShellActions.setShell, (state, { shell }) => ({
        ...state,
        mode: shell,
    })),
);

export const localesReducer = createReducer(
    initalLocalesState,
    on(ShellActions.fetchCountrySelectorData, (state) => ({
        ...state,
    })),
    on(
        ShellActions.fetchCountrySelectorDataSuccess,
        (state, { countrySelectorData, activatedLocales }) => ({
            ...state,
            countrySelectorData,
            activatedLocales,
        }),
    ),
    on(ShellActions.fetchCountrySelectorDataError, (state) => ({
        ...state,
        countrySelectorData: undefined,
        activatedLocales: undefined,
    })),
);

export const supportInfosReducer = createReducer(
    initalSupportInfoState,
    on(ShellActions.fetchSupportInfos, (state) => ({
        ...state,
    })),
    on(
        ShellActions.fetchSupportInfosSuccess,
        (state, { customerServiceDetail, footer }) => ({
            ...state,
            customerServiceDetail,
            footer,
        }),
    ),
    on(ShellActions.fetchSupportInfosFailure, (state) => ({
        ...state,
        customerServiceDetail: "undefined",
        footer: [],
    })),
);

export const reducers: ActionReducerMap<State> = {
    basket: basketReducer,
    banners: bannersReducer,
    locales: localesReducer,
    footerItems: footerItemsReducer,
    supportInfos: supportInfosReducer,
    shell: shellReducer,
};
